<template>
  <div>
    <h1>Site Settings</h1>
    <h2>Pages here. Sorta feeling like the old days.</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
  filters: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
</style>
